export const SIZE_THRESHOLDS = {
  LARGE: 200,
  MEDIUM: 100,
}

export const HEIGHT_THRESHOLDS = {
  HIGH_RISE: 30,
  MID_RISE: 15,
}

export const AGE_THRESHOLDS = {
  NEW: 10,
  CONTEMPORARY: 30,
  MATURE: 50,
}

export const FLOOR_COUNT_THRESHOLD = {
  HIGH_RISE: 6,
  MAX_PROGRESS: 10,
}

export const ICON_COLORS = {
  AREA: 'rgba(59, 130, 246, 0.1)',
  FLOORS: 'rgba(16, 185, 129, 0.1)',
  HEIGHT: 'rgba(139, 92, 246, 0.1)',
  AGE: 'rgba(245, 158, 11, 0.1)',
}
